import { NAME } from './constants';

export const APPEND_CAMPAIGNS = `${NAME}/APPEND_CAMPAIGNS`;
export const RESET = `${NAME}/RESET`;
export const SET_CAMPAIGNS = `${NAME}/SET_CAMPAIGNS`;
export const SET_SORT = `${NAME}/SET_SORT`;
